export const TWO_FA_TYPE_NONE = 'NONE';
export const TWO_FA_TYPE_ZIPCODE = 'ZIPCODE';
export const TWO_FA_TYPE_EMAIL = 'EMAIL';
export const TWO_FA_TYPE_CLIENT_UNIQUE_ID = 'CLIENT_UNIQUE_ID';
